<div id="container" class="container p-0">
    <app-header (propagar)="procesaPropagar($event)" [spanish]="isSpanish"></app-header>
    <app-main *ngIf="isSpanish" [spanish]="true"></app-main>
    <app-footer *ngIf="isSpanish" [spanish]="true"></app-footer> 
    <app-main *ngIf="!isSpanish" [spanish]="false"></app-main>
    <app-footer *ngIf="!isSpanish" [spanish]="false"></app-footer> 
  </div>